module.exports = __webpack_public_path__ + "media/images/hero-payments-555b0f60b7f4c52e2e88cfb5b285f092.png";